export default __webpack_public_path__ + "static/media/1075-01.c060cda0.jpg";